import React, { useState, useEffect } from 'react';
import { FiPlusCircle, FiLoader } from 'react-icons/fi';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_ENDPOINTS } from '../apiConfig';


const AddVacancy = () => {
  const [formData, setFormData] = useState({
    program: '',
    position: '',
    location: '',
    numberOfPositions: 1
  });
  
  const [loading, setLoading] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [loadingPrograms, setLoadingPrograms] = useState(false);

  useEffect(() => {
    fetchPrograms();
  }, []);
  const fetchPrograms = async () => {
    setLoadingPrograms(true);
    try {
      const response = await axios.get(API_ENDPOINTS.GET_CITIES);
      setPrograms(response.data);
    } catch (err) {
      console.error('Error fetching programs:', err);
      toast.error('Failed to fetch programs');
    } finally {
      setLoadingPrograms(false);
    }
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  console.log(formData); // Check the payload being sent to the backend
  setLoading(true);
  try {
    await axios.post(API_ENDPOINTS.ADD_VACANCY, formData);
    setFormData({
      program: '',
      position: '',
      location: '',
      numberOfPositions: 1,
    });
    toast.success('Vacancy added successfully!');
  } catch (error) {
    toast.error(error.response?.data?.error || 'Error adding vacancy');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8 lg:p-12">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#080366]">
            Add <span className="text-[#fbba00]">Vacancy</span>
          </h1>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="lg:flex">
            {/* Left Side - Image/Banner */}
            <div className="lg:w-1/3 bg-[#fbba00] p-8 flex flex-col justify-center">
              <div className="text-[#080366] space-y-4">
                <FiPlusCircle className="w-16 h-16 mb-4" />
                <h2 className="text-2xl font-bold">Create New Vacancy</h2>
                <p className="text-[#080366]">
                  Fill in the details to post a new job vacancy. All fields are required to ensure complete information for candidates.
                </p>
              </div>
            </div>

            {/* Right Side - Form */}
            <div className="lg:w-2/3 p-8">
              <form onSubmit={handleSubmit} className="grid md:grid-cols-2 gap-6">
                <div className="space-y-2 md:col-span-2">
                  <label className="text-sm font-medium text-gray-700 flex items-center">
                    Program
                    {loadingPrograms && (
                      <FiLoader className="ml-2 h-4 w-4 animate-spin text-blue-500" />
                    )}
                  </label>
                  <select
                    value={formData.program}
                    onChange={(e) => setFormData({ ...formData, program: e.target.value })}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-2 focus:ring-[#080366] focus:border-[#080366] transition duration-200"
                    required
                    disabled={loading || loadingPrograms}
                  >
                    <option value="">Select a program</option>
                    {programs.map((program) => (
                      <option key={program._id} value={program._id}>
                        {program.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Profile</label>
                  <input
                    type="text"
                    value={formData.position}
                    onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-2 focus:ring-[#080366] focus:border-[#080366] transition duration-200"
                    required
                    disabled={loading}
                    placeholder="Enter profile title"
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Unit/Project Site</label>
                  <input
                    type="text"
                    value={formData.location}
                    onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-2 focus:ring-[#080366] focus:border-[#080366] transition duration-200"
                    required
                    disabled={loading}
                    placeholder="Enter Unit/Project Site"
                  />
                </div>
{/* 
                <div className="space-y-2 md:col-span-2">
                  <label className="text-sm font-medium text-gray-700">Number of Positions</label>
                  <input
                    type="number"
                    min="1"
                    value={formData.numberOfPositions}
                    onChange={(e) => setFormData({ ...formData, numberOfPositions: parseInt(e.target.value) })}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-2 focus:ring-[#080366] focus:border-[#080366] transition duration-200"
                    required
                    disabled={loading}
                  />
                </div> */}

                <div className="md:col-span-2">
                  <button
                    type="submit"
                    className="w-full bg-[#fbba00] text-[#080366] py-4 px-6 rounded-lg font-medium hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#080366] focus:ring-offset-2 transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
                    disabled={loading || loadingPrograms}
                  >
                    {loading ? (
                      <>
                        <FiLoader className="animate-spin" />
                        <span>Adding...</span>
                      </>
                    ) : (
                      <>
                        <FiPlusCircle />
                        <span>Add Vacancy</span>
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVacancy;